import {createSlice} from '@reduxjs/toolkit'

export const exportListSlice = createSlice({
  name: 'exportList',
  initialState: {
    errorMessage: '',
    showError: false,
    isExporting: false,
    showExportingInfo: false,
    showSuccess: false
  },
  reducers: {
    setExportError: (state, action) => {
      state.errorMessage = action.payload
      state.showError = true
      state.isExporting = false
      state.showExportingInfo = false
      state.showSuccess = false
    },
    clearExportError: (state) => {
      state.errorMessage = ''
      state.showError = false
      state.showSuccess = false
    },
    setIsExporting: (state, action) => {
      state.isExporting = action.payload
      state.showExportingInfo = action.payload
      state.errorMessage = ''
      state.showError = false
      state.showSuccess = false
    },
    hideExportingInfo: (state) => {
      state.showExportingInfo = false
    },
    setExportSuccess: (state, action) => {
      state.isExporting = false
      state.showExportingInfo = false
      state.errorMessage = ''
      state.showError = false
      state.showSuccess = action.payload
    }
  }
})

export const {setExportError, clearExportError, setIsExporting, hideExportingInfo, setExportSuccess} =
  exportListSlice.actions

export default exportListSlice.reducer
